import styles from "./TitleLayout.module.css";
import Sprite from "../object-graphics/Sprite";
import { TILES } from "../../helpers/tiles";
import TitleSvg from "../object-graphics/TitleSvg";
import PressEnterSvg from "../object-graphics/PressEnterSvg";
import { useKeyPress } from "../../hooks/useKeyPress";
import { VERSION } from "../../helpers/consts";

export default function TitleScreen({ onEnter }) {
  useKeyPress("Enter", () => {
    onEnter();
  });
  return (
    <div className={styles.container}>
      <span className={styles.version}>{VERSION}</span>
      <div className={styles.containerInner}>
        <TitleSvg />
        <Sprite frameCoord={TILES.CIABATTA1} size={48} />
        <div className={styles.pressEnterContainer}>
          <button
            onClick={() => {
              onEnter();
            }}
          >
            <PressEnterSvg />
          </button>
        </div>
      </div>
      <p className={styles.credits}>By Drew Conley and Glenn LaBarre </p>
      <span className={styles.version}>{VERSION}</span>
    </div>
  );
}
